import useApi from '@components/Hooks/useApi';
import useBodyClass from '@components/Hooks/useBodyClass';
import useGlobalState from '@components/Hooks/useGlobalState';
import useSections from '@components/Hooks/useSections';
import React, { useEffect } from 'react';
import Cookies from 'universal-cookie';
import Bottom from './Bottom';
import Top from './Top';

const cookies = new Cookies();

const Login: React.FC = () => {

  useBodyClass(['login-page']);
  const [store, dispatch] = useGlobalState();
  const api = useApi(dispatch);
  const { getApp } = useSections();

  const hasSession = () => {
    const session_name = 'oasis_session' + api.getSubDomain();
    const userid_name = 'oasis_userid' + api.getSubDomain();
    const session = cookies.get(session_name);
    const userid = cookies.get(userid_name);
    // console.log('session', session_name, session);
    // console.log('userid', userid_name, userid);
    return session && userid;
  }

  useEffect(() => {
    goHome();
  }, [store.session]);

  const goHome = () => {
    // console.log('hello', hasSession());
    if (hasSession()) {
      const target_page = cookies.get('target_page') as string | undefined | null;
      if (target_page) {
        cookies.remove('target_page', {
          domain: api.getCookieDomain(),
          path: '/',
          secure: true,
          httpOnly: false
        });
        if (target_page.indexOf('/' + getApp() + '/') >= 0) {
          location.replace('#/');
        }
        else if (target_page.startsWith('http')) {
          const parts = URL.parse(target_page);
          location.replace(target_page.replace(parts?.origin ?? '///', ''));
        }
        else {
          location.replace(target_page);
        }
      }
      else {
        location.replace('#/');
      }
    }
  }

  return (
    <div className='page-container'>
      <Top />
      <Bottom />
    </div>
  );
}

export default Login;